import { render, staticRenderFns } from "./WithIconNotificationSection.vue?vue&type=template&id=240cea3f&scoped=true&"
import script from "./WithIconNotificationSection.vue?vue&type=script&lang=ts&"
export * from "./WithIconNotificationSection.vue?vue&type=script&lang=ts&"
import style0 from "./WithIconNotificationSection.vue?vue&type=style&index=0&id=240cea3f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240cea3f",
  null
  
)

export default component.exports